/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetSkuCategories,
    GetPricingDetailsBySkuCategoryID,
    GetPricingDetails,
    GetMarketsByGroupIDForMarketScreen,
    GetProductPricesByProductPriceIDFromMarketPriceScreen,
    SavePricingDetails,
    UpdateProductPriceDetails,
    GetAllGroupsForMarketScreen,
    GetGradeDetails
};

async function GetSkuCategories() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetPricingDetailsBySkuCategoryID(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductDetailsByProductcatogeryIDMultiSelect', '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetGradeDetails() {
    const response = await CommonGet('/api/Pricing/GetGradeDetails', null);
    return response.data;
}

async function GetAllGroupsForMarketScreen() {
    const response = await CommonGet('/api/MarketScreen/GetAllGroupsForMarketScreen', null);
    return response.data;
}

async function GetMarketsByGroupIDForMarketScreen(groupID) {
    const response = await CommonGet('/api/MarketScreen/GetMarketsByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductPricesByProductPriceIDFromMarketPriceScreen(productPriceID) {
    const response = await CommonGet('/api/ProductSellingPrice/GetProductPriceByproductPriceID', 'productPriceID=' + parseInt(productPriceID));
    return response.data;
}

async function SavePricingDetails(model) {
    const response = await CommonPost('/api/Pricing/SavePricingDetails', null, model);
    return response;
}

async function GetPricingDetails(model) {
    const response = await CommonPost('/api/Pricing/GetPricingDetails', null, model);
    return response;
}

async function UpdateProductPriceDetails(values) {
    const response = await CommonPost('/api/ProductSellingPrice/UpdateProductPriceDetails', null, values);
    return response;
}


